import { validateDateOfBirth } from '../helper/Validations';

const haveRequiredFields = tempRequiredFields => (
  tempRequiredFields.find(x => x.field === 'gender' && x.value !== '')
  && tempRequiredFields.find(x => x.field === 'maritalStatus' && x.value !== '')
  && tempRequiredFields.find(x => x.field === 'dateOfBirth' && validateDateOfBirth(x.value))
);

export default haveRequiredFields;
